import { useState } from "react";
import { Box, Popover } from "@mui/material";
import { cn } from "../../utils/classNames";
import { POPOVER_PLACEMENT } from "../../utils/enum";

const triggerBaseClasses = 'cursor-pointer';

const triggerActiveClasses = 'border-b-2 border-content';

const popoverPaperShadow = `0px 9px 28px 8px rgba(0, 0, 0, 0.05),
0px 6px 16px 0px rgba(0, 0, 0, 0.08),
0px 3px 6px -4px rgba(0, 0, 0, 0.12)`;

const POPOVER_PLACEMENTS = {
    [POPOVER_PLACEMENT.TOP_LEFT]: {
        anchorOrigin: { vertical: "top", horizontal: "left" },
        transformOrigin: { vertical: "bottom", horizontal: "left" },
    },
    [POPOVER_PLACEMENT.TOP_RIGHT]: {
        anchorOrigin: { vertical: "top", horizontal: "right" },
        transformOrigin: { vertical: "bottom", horizontal: "right" },
    },
    [POPOVER_PLACEMENT.BOTTOM_LEFT]: {
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        transformOrigin: { vertical: "top", horizontal: "left" },
    },
    [POPOVER_PLACEMENT.BOTTOM_RIGHT]: {
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
        transformOrigin: { vertical: "top", horizontal: "right" },
    },
    [POPOVER_PLACEMENT.LEFT_TOP]: {
        anchorOrigin: { vertical: "top", horizontal: "left" },
        transformOrigin: { vertical: "top", horizontal: "right" },
    },
    [POPOVER_PLACEMENT.LEFT_BOTTOM]: {
        anchorOrigin: { vertical: "bottom", horizontal: "left" },
        transformOrigin: { vertical: "bottom", horizontal: "right" },
    },
    [POPOVER_PLACEMENT.RIGHT_TOP]: {
        anchorOrigin: { vertical: "top", horizontal: "right" },
        transformOrigin: { vertical: "top", horizontal: "left" },
    },
    [POPOVER_PLACEMENT.RIGHT_BOTTOM]: {
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
        transformOrigin: { vertical: "bottom", horizontal: "left" },
    },
};

const XPopover = ({
    id,
    trigger,
    children,
    placement = POPOVER_PLACEMENT.TOP_LEFT,
}) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const placementConfig =
        POPOVER_PLACEMENTS[placement] ||
        POPOVER_PLACEMENTS[POPOVER_PLACEMENT.TOP_LEFT];

    const open = Boolean(anchorEl);

    return (
        <>
            <div
                className={cn(triggerBaseClasses, open && triggerActiveClasses)}
                onClick={(event) => setAnchorEl(event.currentTarget)}
            >
                {trigger}
            </div>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={placementConfig.anchorOrigin}
                transformOrigin={placementConfig.transformOrigin}
                slotProps={{
                    paper: {
                        sx: {
                            boxShadow: popoverPaperShadow,
                            backgroundColor: 'var(--color-surface)',
                        },
                    },
                }}
            >
                <Box>
                    {children}
                </Box>
            </Popover>
        </>
    );
};

export default XPopover;